import React from 'react';
import { Copy } from 'lucide-react';

import { useToaster } from 'hooks/useToaster';
import { Avatar, AvatarImage, AvatarFallback } from '@epoch-ui/components/Avatar/avatar';
import { SheetHeader } from '@epoch-ui/components/Sheet/sheet';

import { useGuestSideSheetContext } from '../guestSideSheetContext';

export const GuestSideSheetHeader = (): React.ReactNode => {
  const {
    guestData: { guest }
  } = useGuestSideSheetContext();
  const { showToast } = useToaster();
  return (
    <SheetHeader>
      <div className="tw-flex tw-items-center tw-gap-4">
        <Avatar className="tw-h-16 tw-w-16 tw-rounded-lg">
          <AvatarImage className="tw-rounded-3xl" src={guest.profilePictureUrl || undefined} />
          <AvatarFallback className="tw-rounded-lg">
            {guest.firstName.charAt(0)}
            {guest.lastName.charAt(0)}
          </AvatarFallback>
        </Avatar>
        <div className="tw-flex tw-flex-col tw-items-start tw-justify-start tw-gap-[2px]">
          <h3 className="tw-m-0 tw-text-xl tw-font-medium tw-leading-7">
            {guest.firstName} {guest.lastName}
          </h3>
          <div className="tw-flex tw-items-center tw-gap-1 tw-self-stretch tw-text-muted-foreground">
            <span className="tw-text-sm tw-font-normal tw-leading-5">{guest.email}</span>
            <button
              type="button"
              className="tw-p-0"
              onClick={() => {
                navigator.clipboard.writeText(guest.email);
                showToast('Email copied to clipboard.');
              }}
            >
              <Copy className="tw-h-4 tw-w-4 tw-text-muted-foreground" />
            </button>
          </div>
        </div>
      </div>
    </SheetHeader>
  );
};
